<!--
    描述：电子保函 -> 退保申请 -> 详情
    时间：2023-02-08
    Created by zcc
-->
<template>
  <div class="member-detail-page">
    <!-- 申请更新信息 -->
    <div class="item">
      <el-divider content-position="left">退保申请信息：</el-divider>
      <div class="main-content">
        <el-row>
          <el-col :span="6"> 业务流水号：{{ objectForm.id }} </el-col>
          <el-col :span="6"> 退保申请单位：{{ objectForm.tenantName }} </el-col>
          <el-col :span="6">
            统一社会信用代码：{{ objectForm.creditCode }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6"> 标段名称：{{ objectForm.bidName }} </el-col>
          <el-col :span="6"> 标段编号：{{ objectForm.bidNo }} </el-col>
          <el-col :span="6">
            标段状态类型：{{ objectForm.sectionStatus }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6"> 投标申请编号：{{ objectForm.lgNo }} </el-col>
          <el-col :span="6">
            瀚华保函编号：{{ objectForm.guaranteeNumber }}
          </el-col>
          <el-col :span="6">
            经办人联系电话：{{ objectForm.operatorPhone }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24"> 退保原因：{{ objectForm.memo }} </el-col>
        </el-row>
        <el-row>
          <el-col :span="6"> 申请人：{{ objectForm.applyUserName }} </el-col>
          <el-col :span="6"> 申请时间：{{ objectForm.createDate }} </el-col>
          <el-col :span="6"> 业务来源：{{ objectForm.sysSourceName }} </el-col>
        </el-row>
      </div>
    </div>
    <!-- 更新状态 -->
    <div class="item">
      <el-divider content-position="left">退保信息：</el-divider>
      <div class="main-content">
        <el-row>
          <el-col :span="6">
            处理结果：
            <span class="showStatus">
              <span v-if="objectForm.status == '1'" class="between">
                退保处理中
              </span>
              <span v-else-if="objectForm.status == '2'" class="success">
                退保成功
              </span>
              <span v-else-if="objectForm.status == '3'" class="fail">
                退保失败
              </span>
            </span>
          </el-col>
          <el-col :span="6"> 处理意见：{{ objectForm.auditOpinion }} </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            保函编号：{{ objectForm.guaranteeNumber }}
          </el-col>
          <el-col :span="6"> 投保申请编号：{{ objectForm.lgNo }} </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import * as API from "api/modules/bh/bh-surrender-application";
export default {
  name: "detail",
  data() {
    return {
      objectForm: {
        id: "", //业务流水号
        tenantName: "", //退保申请单位
        creditCode: "", //统一社会信用代码
        bidName: "", //标段名称
        bidNo: "", //标段编号
        sectionStatus: "", //标段状态类型
        lgNo: "", //投标申请编号
        guaranteeNumber: "", //瀚华保函编号
        operatorPhone: "", //经办人联系电话
        memo: "", //退保原因
        applyUserName: "", //申请人
        createDate: "", //申请时间
        sysSourceName: "", //业务来源
        status: "", //处理结果
        auditOpinion: "", //处理意见
      },
    };
  },
  mounted() {},
  computed: {
    designUserId() {
      return this.$route.query.id;
    },
  },
  created() {
    this.getSelectSurrender();
  },
  methods: {
    getSelectSurrender() {
      let param = {
        id: this.designUserId,
      };
      API.getSelectSurrender(param).then((res) => {
        if (res.operationCode == 1) {
          Object.keys(this.objectForm).forEach(
            (key) => (this.objectForm[key] = res.data[key])
          );
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.member-detail-page {
  .item {
    .main-content {
      font-family: "Arial Normal", "Arial";
      font-weight: 400;
      font-style: normal;
      font-size: 13px;
      color: #333333;
      line-height: normal;
      padding: 0 40px;

      .el-row {
        padding: 10px 0px;
      }

      .showStatus {
        .success {
          color: #008000;
        }

        .fail {
          color: #ff0000;
        }

        .between {
          color: #ff9900;
        }
      }
    }
  }
}
</style>
